export default __webpack_public_path__ + "static/media/cris.c8ea3756.png";